import Tours from './components/Tour';
import './App.css';
import data from './data.js';
import {useState} from 'react';

function App() {
  const[tour,setTour] = useState(data);
  function removeTour(id) {
    const newTours = tour.filter(tour => tour.id !== id);
    setTour(newTours);

  }

  if(tour.length === 0){
    return(
      <div className='justify-center items-center h-[100vh] bg-red-300 flex flex-col'>
        <h1 className='font-bold'>No More Tours</h1>
          <button onClick={() => setTour(data)} className='mt-[18px] py-[10px] px-[80px] cursor-pointer border border-solid rounded-xl font-bold  hover:bg-black hover:text-white hover:transition-all'>Refresh</button>
        
      </div>
    );
  }
  return (
    <div>
        <Tours tour={tour} removeTour={removeTour}></Tours>
    </div> 
    
  );
}

export default App;
